module.exports = __webpack_public_path__ + "static/media/biocore-logo.2a1a6e6f.png";